import React from "react";
import { View, StyleSheet } from "react-native";
import RText from "../../../../RText/RText";
import variables from "../../../../../styles/variables";
import { Status } from "../../../../../types/status";

type Props = {
  message?: Status;
};

const { colors, spacing } = variables;

const StatusMessage = ({ message }: Props) => {
  if (!message || message == "resulted" || message == "scheduled") return;

  return (
    <View
      style={[
        styles.statusMessage,
        { backgroundColor: backgroundColor[message] },
      ]}
    >
      <RText
        uppercase
        family="secondary"
        weight="bold"
        color={textColor[message]}
      >
        {text[message]}
      </RText>
    </View>
  );
};

const backgroundColor = {
  abandoned: colors.palette.watchAndBet.red,
  resulted: colors.palette.watchAndBet.green,
  started: colors.palette.watchAndBet.yellow,
  scheduled: colors.palette.watchAndBet.yellow,
  void: colors.palette.watchAndBet.red,
};

const text = {
  abandoned: "abandoned",
  started: "race off and running",
  void: "void",
};

const textColor = {
  abandoned: "white",
  started: "primary",
  void: "white",
};

const styles = StyleSheet.create({
  statusMessage: {
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: spacing.xxsmall,
    width: "100%",
  },
});

export default StatusMessage;
